import { useEffect, useMemo, useState } from 'react'
import { Button, Dialog, DialogTitle, Typography } from '@mui/material'
import axios from 'axios'
import { format } from 'date-fns'
import ReactGA from 'react-ga4'
import { useNavigate, useParams } from 'react-router-dom'
import { AppConstants, Channel, LeadStage } from 'AppConstants/AppConstants'
import Footer from 'components/Footer'
import Header from 'components/Header'
import {
  SetPaymentPlansOfferFlow,
  SetPurchasedPlanOfferFlow,
  SetSelectedSlotOfferFlow,
  SetTimeLeftOfferFlow,
} from 'redux/Offers/persist'
import { useAppDispatch, useAppSelector } from 'redux/store'
import styles from './ConfirmAppointment.module.scss'

const ConfirmAppointment = () => {
  const styless: any = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //   position: 'absolute' as 'absolute',
    //   top: '44%',
    //   left: '47.5%',
    //   transform: 'translate(-50%, -50%)',
    width: 300,
    height: 170,
    overflow: 'hidden',
    backgroundColor: '#050624',
    color: 'white',
    borderRadius: '8px',
    p: 4,
  }
  const { id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const appointmentTime = useAppSelector((state) => state.selectedSlotOffer.selectedSlotOfferFlow)
  const paymentDone = useAppSelector((state) => state.paymentDoneOffer.paymentDone)
  const plans = useAppSelector((state) => state.paymentPlansOffer.plans)
  const visitCount = useAppSelector((state) => state.visitCountOfferFlow.visitCount)
  const studios = useAppSelector((state) => state.studiosOffers.studiosOffers)
  const selectedStudio = useAppSelector((state) => state.selectedStudioOffers.studioOffers)
  const isMoreThanOneStudio = useAppSelector((state) => state.isMoreThanOneStudioOffers.isMoreThanOneStudioOffers)
  // const slotBookedAlready = useAppSelector((state) => state.slotBookedAlreadyReferral.slotBookedAlreadyReferralFlow)
  const [error, setError] = useState(false)
  const [slotNotFound, setSlotNotFound] = useState(false)

  // const [timeLeft, setTimeLeft] = useState(299)
  const timeLeft = useAppSelector((state) => state.timeLeftOfferFlow.timeLeft)

  const plan = useMemo(() => {
    if (plans) {
      const filterOnDemand = plans?.filter((p) => p.type === 'on-demand')
      return filterOnDemand
    } else {
      return null
    }
  }, [plans])

  console.log(plan, 'plan list')

  const schedulePhysicalVisit = async () => {
    if (appointmentTime?.scheduleObject) {
      const response: any = await axios
        .post(AppConstants.API_URL + '/visit/chiropractor/appointment', appointmentTime.scheduleObject, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        })
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })

      if (response?.data?.code === 'success') {
        // ReactGA.event('conversion', {
        //   send_to: process.env.REACT_APP_GA_CONVERSION_ID || 'AW-11337579902/40e2CN_xnqkZEP76lp4q',
        //   value: plan && plan[0] && plan[0]?.amount > 0 ? plan[0].amount / 100 : 0,
        //   currency: 'USD',
        // })
        navigate(`/offers/${id}/welcome`)
      } else {
        if (response?.data?.code === 'slot_booked_already') {
          setError(true)
        } else if (response?.data?.code === 'slot_not_found') {
          setSlotNotFound(true)
        }
        return false
      }
    } else {
      return false
    }
  }

  async function purchasePlan(selectedPlanId: string | undefined) {
    try {
      const response: any = await axios
        .post(
          `${AppConstants.API_URL}/payment-plan/purchase`,
          { planId: selectedPlanId, quantity: 1 },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('userToken')}`,
              'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
            },
          },
        )
        .then((res) => {
          if (res && res?.data && res?.data?.data) {
            // setClientSecret(res?.data?.data?.clientSecret)
            // setPlanIdSecret(res?.data?.data?.paymentId)
            dispatch(SetPurchasedPlanOfferFlow(res?.data?.data))
            navigate(`/offers/${id}/payment`)
          }
        })
        .catch((err) => {
          if (err) {
            alert('Something went wrong. Please try again.')
          }
        })
    } catch (error) {
      console.error(error)
    }
  }

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        {
          stage: LeadStage.confirmation,
          channel: plan && plan?.length > 0 ? (plan[0]?.amount > 0 ? Channel.marketing : Channel.free) : null,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    ReactGA.event('page_view', {
      page_title: 'Offers|Payment',
      page_location: `/offers/${id}/payment`,
    })
  }, [])

  useEffect(() => {
    dispatch(SetTimeLeftOfferFlow(timeLeft ?? 299))
  }, [])

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        dispatch(SetTimeLeftOfferFlow(timeLeft && timeLeft - 1))
      }, 1000)

      return () => clearInterval(timerId)
    }
  }, [timeLeft])

  return (
    <>
      <div className={styles.container}>
        <Header
          headerText=""
          showBackButton={true}
          onBack={() => {
            navigate(`/offers/${id}/physical-visit`)
          }}
        ></Header>

        <div className={styles.locationContainer}>
          <div className={styles.confirmHeader}>Confirm your appointment.</div>
          {studios && (
            <div className={styles.locationDetails}>
              <div className={styles.locationTextContainer}>
                <div className={styles.locationWrapper}>
                  <div className={styles.appointmentTime}>
                    {appointmentTime
                      ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'EEEE, MMM dd')
                      : ''}
                    <div>
                      {appointmentTime
                        ? format(new Date(appointmentTime?.scheduleObject.appointmentTime), 'h:mm a')
                        : ''}
                    </div>
                  </div>
                  <div>
                    <div className={styles.locationText} style={{ fontWeight: 700 }}>
                      {isMoreThanOneStudio ? selectedStudio?.name : studios[0]?.name}
                    </div>
                    <div className={styles.locationText}>
                      {isMoreThanOneStudio ? selectedStudio?.address : studios[0]?.address}
                    </div>
                    {isMoreThanOneStudio ? (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{selectedStudio?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{selectedStudio?.state}</div>
                        <div>{selectedStudio?.zipCode}</div>
                      </div>
                    ) : (
                      <div className={styles.cityAndState}>
                        <div style={{ marginRight: '4px' }}>{studios[0]?.city.name + ','}</div>
                        <div style={{ marginRight: '4px', textTransform: 'uppercase' }}>{studios[0]?.state}</div>
                        <div>{studios[0]?.zipCode}</div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <img
                style={{ width: '145px', height: '150px', objectFit: 'cover' }}
                className={styles.mapImageItem}
                src={isMoreThanOneStudio ? selectedStudio?.mapImage || '' : studios[0]?.mapImage || ''}
                alt="map"
                // onClick={() => {
                //   if (studios && selectedStudio && selectedStudio?.mapLocation && isMoreThanOneStudio) {
                //     window.open(selectedStudio.mapLocation, '_blank')
                //   } else if (studios && studios.length === 1 && studios[0]?.mapLocation) {
                //     window.open(studios[0].mapLocation, '_blank')
                //   }
                //   //   window.location.href =
                //   //     'https://www.google.com/maps/place/302+Mott+St,+New+York,+NY+10012,+USA/@40.7248592,-73.9940347'
                // }}
              />
            </div>
          )}

          {error && (
            <Dialog
              onClose={() => {
                // setError(false)
              }}
              open={error}
              PaperProps={{
                style: {
                  background: 'var(--color-background)',
                  borderRadius: '12px',
                  padding: '10px 12px',
                  minWidth: 300,
                  maxWidth: 300,
                  minHeight: 'auto',
                  // height: 170,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  flex: 1, // align everything to the left
                  textAlign: 'left', // global text alignment
                },
              }}
            >
              <DialogTitle
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: 'var(--color-text-primary)',
                  textAlign: 'left',
                  marginBottom: '12px',
                  padding: 0,
                  width: '100%',
                }}
              >
                Time Limit Reached
              </DialogTitle>
              <Typography
                style={{
                  color: 'var(--color-text-primary)',
                  fontSize: '14px',
                  textAlign: 'left',
                  marginBottom: '24px',
                  lineHeight: 1.5,
                  width: '100%',
                }}
              >
                Your booking session expired. Please select another available slot to continue.
              </Typography>
              <Button
                color="primary"
                style={{
                  marginBottom: '0.3rem',
                  height: '42px',
                  padding: '0px 8px 0px 8px',
                  fontSize: '14px',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  setError(false)
                  // dispatch(SetSlotBookedAlreadyReferralFlow(false))
                  navigate(`/offers/${id}/physical-visit`)
                }}
              >
                Reschedule
              </Button>
            </Dialog>
          )}
          {slotNotFound && (
            <Dialog
              onClose={() => {
                // setError(false)
              }}
              open={slotNotFound}
              PaperProps={{
                style: {
                  background: 'var(--color-background)',
                  borderRadius: '12px',
                  padding: '10px 12px',
                  minWidth: 300,
                  maxWidth: 300,
                  minHeight: 'auto',
                  // height: 170,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  flex: 1, // align everything to the left
                  textAlign: 'left', // global text alignment
                },
              }}
            >
              <DialogTitle
                style={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: 'var(--color-text-primary)',
                  textAlign: 'left',
                  marginBottom: '12px',
                  padding: 0,
                  width: '100%',
                }}
              >
                Time Limit Reached
              </DialogTitle>
              <Typography
                style={{
                  color: 'var(--color-text-primary)',
                  fontSize: '14px',
                  textAlign: 'left',
                  marginBottom: '24px',
                  lineHeight: 1.5,
                  width: '100%',
                }}
              >
                Your booking session expired. Please select another available slot to continue.
              </Typography>
              <Button
                color="primary"
                style={{
                  marginBottom: '0.3rem',
                  height: '42px',
                  padding: '0px 8px 0px 8px',
                  fontSize: '14px',
                  alignSelf: 'center',
                }}
                onClick={() => {
                  setSlotNotFound(false)
                  navigate(`/offers/${id}/physical-visit`)
                }}
              >
                Reschedule
              </Button>
            </Dialog>
          )}
        </div>
        {plan && plan[0]?.amount !== 0 && (
          <div className={styles.offerDetails}>
            <span className={styles.offerDetailsHeader}>Offer Details</span>
            <div className={styles.offerText}>
              Due to limited availability for this promotion, we require a non-refundable payment of
              <b> ${plan[0]?.amount / 100}</b> to secure your spot. Please complete your payment below. We're looking
              forward to meeting you in our studio!
            </div>
          </div>
        )}
        {plan && plan[0]?.amount !== 0 && (
          <div className={styles.offerExpires}>
            Offer Expires In: <span className={styles.timer}>{formatTime(timeLeft || 0)}</span>
          </div>
        )}
        {/* {plan && plan[0]?.amount === 0 && (
          <div className={styles.cancellationPolicy}>
            <div className={styles.policyHeader}>Cancellation Policy</div>
            <div className={styles.cancellation}>
              Appointments canceled or rescheduled at least 12 hours in advance of the appointment time will not incur a
              penalty. Cancellations made between 12 hours and 1 hour in advance of the appointment time will result in
              a $10 penalty. If canceled less than 1 hour in advance of the appointment time or in the case of a
              no-show, a $20 penalty will apply. This policy ensures that our doctors can offer the slot to other
              patients in need of care.
            </div>
          </div>
        )} */}
        <Footer
          buttonText={
            plan && plan[0]?.amount === 0
              ? 'Confirm'
              : !paymentDone && plan && visitCount?.onDemandCount === 0
              ? `Confirm and Pay $${plan[0]?.amount / 100}`
              : 'Confirm'
          }
          isLoading={false}
          trackerIndex={isMoreThanOneStudio ? 5 : 4}
          shouldShowFour={true}
          shouldShowFive={true}
          shouldShowSix={isMoreThanOneStudio}
          isDisabled={false}
          buttonType={'button'}
          onButtonClick={() => {
            if (plan && plan[0]?.amount === 0 && appointmentTime?.scheduleObject) {
              schedulePhysicalVisit()
            } else if (plan && plan[0]?.amount !== 0 && appointmentTime?.scheduleObject) {
              if (!paymentDone && visitCount?.onDemandCount === 0) {
                purchasePlan(plan[0]?.id)
              } else {
                schedulePhysicalVisit()
              }
            }
          }}
        ></Footer>
      </div>
    </>
  )
}

export default ConfirmAppointment
